import React, { useEffect, useState } from 'react';

export type CheckboxItemType = {
  label: string;
  value: string;
  description?: string;
};

type Props = {
  className?: string;
  customValue: string;
  value?: string;
  options: Array<CheckboxItemType>;
  onSelectItem: (value: string) => void;
  onCustomValueChange: (value: string, key: string) => void;
  isError?: boolean;
  errorText?: string;
  isCustomValue?: boolean;
};

const CheckboxItemsList: React.FC<Props> = ({
  className,
  options,
  onSelectItem,
  customValue,
  value = '',
  onCustomValueChange,
  isError,
  errorText,
  isCustomValue
}) => {
  const [selectedItem, setSelectedItem] = useState<string>(value);
  
  useEffect(() => {
    if (value) {
      setSelectedItem(value);
    } 
  },[value]);

  const handleSelectItem = (itemValue: string) => {
    const newValue = selectedItem === itemValue ? '' : itemValue;
    setSelectedItem(newValue);
    onSelectItem(newValue);
  };

  const handleChangeCustomValue = (value: string) => {
    onCustomValueChange(value, 'otherText');
  };

  const isItemSelected = (itemValue: string) => {
    return selectedItem === itemValue;
  };

  return (
    <div className={`checkbox-list ${className}`}>
      {options.length
        ? options.map((item) => (
            <div
              key={item.value}
              role="button"
              className="checkbox-list__item"
              onClick={() => handleSelectItem(item.value)}
            >
              <div className="checkbox-list__item-button">
                <div className={`checkbox-selector ${isItemSelected(item.value) ? 'active' : ''}`} />
              </div>
              {isCustomValue && isItemSelected(item.value) ? (
                <input
                  type="text"
                  value={customValue}
                  onChange={(e) => handleChangeCustomValue(e.target.value)}
                  className="checkbox-list__item_label checkbox-list__custom-input"
                  autoFocus
                />
              ) : (
                <div 
                  className="checkbox-list__item_label"
                  dangerouslySetInnerHTML={{ __html: item.label }}
                />
              )}
            </div>
          ))
        : null}
        {isError && <span className="input-label-error">{errorText}</span>}
    </div>
  );
};

export default CheckboxItemsList; 